module.exports = __webpack_public_path__ + "img/order-management.5e8fb90d.jpg";